<div
  class="modal fade"
  id="settingsModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="settingsModalLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered modal-fullscreen"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="settingsModalLabel">
          {{'CONFIGURATION' | translate}}
        </h5>
        <button class="toggle-btn" (click)="toggleSidebar()">
          <svg *ngIf="showSidebar" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
          <svg *ngIf="!showSidebar" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
        <button
          type="button"
          class="btn-close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeModal()"
        ></button>
      </div>
      <div class="modal-body h-100 bg-gray p-0">
        <div class="container-fluid h-100">
          <div class="row h-100">
            <div class="col-md-3 h-100 fixed-top bg-white sidebar" [ngClass]="{'sidebar-collapsed': !showSidebar}">
              <nav>
                <ul class="nav nav-pills flex-column" role="tablist" aria-orientation="vertical">
                  <li class="nav-item" *ngIf="permissions.generalInfo">
                    <a class="nav-link active" data-bs-toggle="pill" href="#step1" role="tab">

                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
                      </svg>
                      <span class="nav-text">{{'INFORMATION_GENERAL' | translate}}</span>
                    </a>
                  </li>
                  <li class="nav-item" *ngIf="hasAccess">
                    <a class="nav-link" data-bs-toggle="pill" href="#step2" role="tab">

                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                      </svg>
                      <span class="nav-text">{{'USERS_AND_ROLES' | translate}}</span>
                    </a>
                  </li>
                  <li class="nav-item" *ngIf="permissions.collections">
                    <a class="nav-link" data-bs-toggle="pill" href="#step4" role="tab">

                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 3h18v18H3z"></path><path d="M3 9h18"></path><path d="M9 3v18"></path>
                      </svg>
                      <span class="nav-text">{{'COLLECTIONS' | translate}}</span>
                    </a>
                  </li>
                  <li class="nav-item" *ngIf="permissions.supliers">
                    <a class="nav-link" data-bs-toggle="pill" href="#step8" role="tab">

                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                      </svg>
                      <span class="nav-text">{{'SUPPLIERS' | translate}}</span>
                    </a>
                  </li>
                  <li class="nav-item" *ngIf="permissions.shopPoints">
                    <a class="nav-link" data-bs-toggle="pill" href="#stepShopPoints" role="tab">

                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 5a4 4 0 0 1-8 0"></path>
                      </svg>
                      <span class="nav-text">{{'POINTS_OF_SALE' | translate}}</span>
                    </a>
                  </li>
                  <li class="nav-item" *ngIf="permissions.paymentMethods">
                    <a class="nav-link" data-bs-toggle="pill" href="#stepPaymentMethods" role="tab">

                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line>
                      </svg>
                      <span class="nav-text">{{'PAYMENT_METHODS' | translate}}</span>
                    </a>
                  </li>
                  <li class="nav-item" *ngIf="permissions.shippingCosts">
                    <a class="nav-link" data-bs-toggle="pill" href="#shippingCosts" role="tab">

                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-truck"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
                      <span class="nav-text">{{'SHIPPING_COST' | translate }}</span>
                    </a>
                  </li>
                  <li class="nav-item" *ngIf="permissions.themingService">
                    <a class="nav-link" data-bs-toggle="pill" href="#stepSubscriptions" role="tab">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9 6.25C7.48122 6.25 6.25 7.48122 6.25 9C6.25 10.5188 7.48122 11.75 9 11.75C10.5188 11.75 11.75 10.5188 11.75 9C11.75 7.48122 10.5188 6.25 9 6.25ZM7.75 9C7.75 8.30965 8.30965 7.75 9 7.75C9.69036 7.75 10.25 8.30965 10.25 9C10.25 9.69036 9.69036 10.25 9 10.25C8.30965 10.25 7.75 9.69036 7.75 9Z" fill="#000000"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M9 12.25C7.80424 12.25 6.68461 12.4907 5.83616 12.915C5.03258 13.3168 4.25 14.0106 4.25 15L4.24987 15.0625C4.24834 15.5728 4.24576 16.4322 5.06023 17.0218C5.43818 17.2953 5.9369 17.4698 6.55469 17.581C7.1782 17.6932 7.97721 17.75 9 17.75C10.0228 17.75 10.8218 17.6932 11.4453 17.581C12.0631 17.4698 12.5618 17.2953 12.9398 17.0218C13.7542 16.4322 13.7517 15.5728 13.7501 15.0625L13.75 15C13.75 14.0106 12.9674 13.3168 12.1638 12.915C11.3154 12.4907 10.1958 12.25 9 12.25ZM5.75 15C5.75 14.8848 5.86285 14.5787 6.50698 14.2566C7.10625 13.957 7.98662 13.75 9 13.75C10.0134 13.75 10.8937 13.957 11.493 14.2566C12.1371 14.5787 12.25 14.8848 12.25 15C12.25 15.6045 12.2115 15.6972 12.0602 15.8067C11.9382 15.895 11.6869 16.0134 11.1797 16.1047C10.6782 16.1949 9.97721 16.25 9 16.25C8.02279 16.25 7.3218 16.1949 6.82031 16.1047C6.31311 16.0134 6.06182 15.895 5.93977 15.8067C5.78849 15.6972 5.75 15.6045 5.75 15Z" fill="#000000"></path> <path d="M19 12.75C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H15C14.5858 11.25 14.25 11.5858 14.25 12C14.25 12.4142 14.5858 12.75 15 12.75H19Z" fill="#000000"></path> <path d="M19.75 9C19.75 9.41422 19.4142 9.75 19 9.75H14C13.5858 9.75 13.25 9.41422 13.25 9C13.25 8.58579 13.5858 8.25 14 8.25H19C19.4142 8.25 19.75 8.58579 19.75 9Z" fill="#000000"></path> <path d="M19 15.75C19.4142 15.75 19.75 15.4142 19.75 15C19.75 14.5858 19.4142 14.25 19 14.25H16C15.5858 14.25 15.25 14.5858 15.25 15C15.25 15.4142 15.5858 15.75 16 15.75H19Z" fill="#000000"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.94358 3.25H14.0564C15.8942 3.24998 17.3498 3.24997 18.489 3.40314C19.6614 3.56076 20.6104 3.89288 21.3588 4.64124C22.1071 5.38961 22.4392 6.33856 22.5969 7.51098C22.75 8.65018 22.75 10.1058 22.75 11.9435V12.0564C22.75 13.8942 22.75 15.3498 22.5969 16.489C22.4392 17.6614 22.1071 18.6104 21.3588 19.3588C20.6104 20.1071 19.6614 20.4392 18.489 20.5969C17.3498 20.75 15.8942 20.75 14.0565 20.75H9.94359C8.10585 20.75 6.65018 20.75 5.51098 20.5969C4.33856 20.4392 3.38961 20.1071 2.64124 19.3588C1.89288 18.6104 1.56076 17.6614 1.40314 16.489C1.24997 15.3498 1.24998 13.8942 1.25 12.0564V11.9436C1.24998 10.1058 1.24997 8.65019 1.40314 7.51098C1.56076 6.33856 1.89288 5.38961 2.64124 4.64124C3.38961 3.89288 4.33856 3.56076 5.51098 3.40314C6.65019 3.24997 8.10583 3.24998 9.94358 3.25ZM5.71085 4.88976C4.70476 5.02503 4.12511 5.27869 3.7019 5.7019C3.27869 6.12511 3.02503 6.70476 2.88976 7.71085C2.75159 8.73851 2.75 10.0932 2.75 12C2.75 13.9068 2.75159 15.2615 2.88976 16.2892C3.02503 17.2952 3.27869 17.8749 3.7019 18.2981C4.12511 18.7213 4.70476 18.975 5.71085 19.1102C6.73851 19.2484 8.09318 19.25 10 19.25H14C15.9068 19.25 17.2615 19.2484 18.2892 19.1102C19.2952 18.975 19.8749 18.7213 20.2981 18.2981C20.7213 17.8749 20.975 17.2952 21.1102 16.2892C21.2484 15.2615 21.25 13.9068 21.25 12C21.25 10.0932 21.2484 8.73851 21.1102 7.71085C20.975 6.70476 20.7213 6.12511 20.2981 5.7019C19.8749 5.27869 19.2952 5.02503 18.2892 4.88976C17.2615 4.75159 15.9068 4.75 14 4.75H10C8.09318 4.75 6.73851 4.75159 5.71085 4.88976Z" fill="#000000"></path> </g></svg>
                      <span class="nav-text">{{'SUBSCRIPTIONS' | translate}}</span>
                    </a>
                  </li>
                  <li class="nav-item" *ngIf="permissions.themingService">
                    <a class="nav-link" data-bs-toggle="pill" href="#step5" role="tab">

                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
                      </svg>
                      <span class="nav-text">{{'STORE_THEME' | translate}}</span>
                    </a>
                  </li>
                  <li class="nav-item" *ngIf="permissions.pages">
                    <a class="nav-link" data-bs-toggle="pill" href="#pages" role="tab">

                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                      </svg>
                      <span class="nav-text">{{'PAGES' | translate}}</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" data-bs-toggle="pill" href="#currentPlan" role="tab">

                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline>
                      </svg>
                      <span class="nav-text">{{'CURRENT_PLAN' | translate}}</span>
                    </a>
                  </li>
                  <li class="nav-item"  *ngIf="permissions.policies">
                    <a class="nav-link" data-bs-toggle="pill" href="#policies" role="tab">

                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>
                      </svg>
                      <span class="nav-text">{{'OUR_POLICIES' | translate}}</span>
                    </a>
                  </li>
                  <li class="nav-item" *ngIf="permissions.faqs">
                    <a class="nav-link" data-bs-toggle="pill" href="#stepFAQs" role="tab">

                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line>
                      </svg>
                      <span class="nav-text">{{'FREQUENT_QUESTIONS' | translate}}</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" (click)="activeTab = 'stepMFA'" data-bs-toggle="pill" href="#stepMFA" role="tab">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/><path d="M9 17l2 2 4-4"/>
                      </svg>
                      <span class="nav-text">{{'MFA' | translate}}</span>
                    </a>
                  </li>
                  <li class="nav-item" *ngIf="permissions.emailTemplate">
                    <a class="nav-link" (click)="activeTab = 'emailTemplateEditor'" data-bs-toggle="pill" href="#emailTemplateEditor" role="tab">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
                        <rect x="2" y="3" width="20" height="18" rx="2" ry="2"></rect><line x1="2" y1="8" x2="22" y2="8"></line><rect x="4" y="10" width="8" height="4" rx="1"></rect><rect x="4" y="16" width="8" height="3" rx="1"></rect><rect x="14" y="10" width="6" height="9" rx="1"></rect>
                      </svg>
                      <span class="nav-text">{{'TEMPLATES' | translate}}</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="col-md-9 offset-md-3 h-100 content-area" [ngClass]="{'content-expanded': !showSidebar}">
              <div class="tab-content">
                <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'step1'}" id="step1" role="tabpanel">
                  <app-general-info></app-general-info>
                </div>
                <div class="tab-pane fade" id="step2" role="tabpanel">
                  <div *ngIf="getListingUsers()">
                    <app-users></app-users>
                  </div>
                  <div *ngIf="getEditingOwner()">
                    <app-user-profile></app-user-profile>
                  </div>
                  <div *ngIf="getCreatingUser()">
                    <app-add-staff></app-add-staff>
                  </div>
                  <div *ngIf="isEditingUser()">
                    <app-user-details [username]="getEditingUser()"></app-user-details>
                  </div>
                </div>
                <div class="tab-pane fade" id="step4" role="tabpanel">
                  <div *ngIf="getListingCollections()">
                    <app-collections></app-collections>
                  </div>
                  <div *ngIf="getCreatingCollection()">
                    <app-create-collection></app-create-collection>
                  </div>
                  <div *ngIf="isEditingCollection()">
                    <app-edit-collection [collectionId]="getEditingCollection()"></app-edit-collection>
                  </div>
                </div>
                <div class="tab-pane fade" id="stepSubscriptions" role="tabpanel">
                  <div *ngIf="getListingSubscriptions()">
                    <app-client-subscriptions></app-client-subscriptions>
                  </div>
                  <div *ngIf="getCreatingSubscription()">
                    <app-create-client-subscription></app-create-client-subscription>
                  </div>
                  <div *ngIf="isEditingSubscription()">
                    <app-edit-client-subscription [subscriptionId]="getEditingSubscription()"></app-edit-client-subscription>
                  </div>
                </div>
                <div class="tab-pane fade" id="step8" role="tabpanel">
                  <div *ngIf="getListingSuppliers()">
                    <app-supplier></app-supplier>
                  </div>
                  <div *ngIf="getCreatingSupplier()">
                    <app-create-supplier></app-create-supplier>
                  </div>
                  <div *ngIf="isEditingSupplier()">
                    <app-edit-supplier [supplierId]="getEditingSupplier()"></app-edit-supplier>
                  </div>
                </div>
                <div class="tab-pane fade" id="step5" role="tabpanel">
                  <app-theming-settings></app-theming-settings>
                </div>
                <div class="tab-pane fade" id="pages" role="tabpanel">
                  <app-pages></app-pages>
                </div>
                <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'currentPlan'}" id="currentPlan" role="tabpanel">
                  <app-current-plan></app-current-plan>
                </div>
                <div class="tab-pane fade" id="stepShopPoints" role="tabpanel">
                  <div *ngIf="getListingShopPoints()">
                    <app-shop-points></app-shop-points>
                  </div>
                  <div *ngIf="getCreatingShopPoint()">
                    <app-create-shop-point></app-create-shop-point>
                  </div>
                  <div *ngIf="isEditingShopPoint()">
                    <app-edit-shop-point [shopPointId]="getEditingShopPoint()"></app-edit-shop-point>
                  </div>
                </div>
                <div class="tab-pane fade" id="stepPaymentMethods" role="tabpanel">
                  <div *ngIf="getListingPaymentMethods()">
                    <app-payment-settings></app-payment-settings>
                  </div>
                  <div *ngIf="getCreatingPaymentMethod()">
                    <app-create-payment></app-create-payment>
                  </div>
                  <div *ngIf="isEditingPaymentMethod()">
                    <app-edit-payment [paymentId]="getEditingPaymentMethod()"></app-edit-payment>
                  </div>
                </div>
                <div class="tab-pane fade" id="policies" role="tabpanel">
                  <app-policies-section></app-policies-section>
                </div>
                <div class="tab-pane fade" id="stepFAQs" role="tabpanel">
                  <div *ngIf="getListingFAQs()">
                    <app-frequent-questions></app-frequent-questions>
                  </div>
                </div>
                <div class="tab-pane fade" id="stepMFA" role="tabpanel">
                  <app-setup-mfa></app-setup-mfa>
              </div>
                <div class="tab-pane fade" id="emailTemplateEditor" role="tabpanel">
                  <app-templates></app-templates>
              </div>
              <div class="tab-pane fade" id="shippingCosts" role="tabpanel">
                  <app-shipping-costs></app-shipping-costs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
